<script setup lang="ts">
const { data: partners } = await useAsyncData('copilot', () => $larafetch(`/copilot`))
const currentPartner = ref(0)

const partnerDisplayOrder = [678, 626, 643, 520, 633, 690, 607, 720, 709, 707, 687, 701, 706, 718, 708, 715, 699, 677]

const orderedPartners = computed(() => {
  if (!partners.value?.data) return []

  return [...partners.value.data].sort((a, b) => {
    const indexA = partnerDisplayOrder.indexOf(a.id)
    const indexB = partnerDisplayOrder.indexOf(b.id)

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB
    }

    if (indexA !== -1) return -1
    if (indexB !== -1) return 1

    return 0
  })
})
</script>

<template>
  <div>
    <CopilotBand
      v-if="orderedPartners[currentPartner]"
      :partner="orderedPartners[currentPartner]"
      heading-type="h1"
    >
      <MarketPreferredSuppliers class="text-supplement" />
    </CopilotBand>

    <Band>
      <Heading
        type="h2"
        variant="h3"
      >
        {{ $t('choose_partner') }}
      </Heading>
      <div class="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4">
        <NuxtLink
          v-for="(partner, index) in orderedPartners"
          :key="partner.slug"
          :to="`/${partner.slug}/website`"
          class="flex h-28 items-center justify-center rounded-lg border p-6 transition-all hover:shadow-md"
          :alt="partner.name"
          @mouseenter="currentPartner = index"
        >
          <NuxtImg
            :src="partner.logo"
            height="40"
            class="max-h-8"
          />
        </NuxtLink>
      </div>
    </Band>
  </div>
</template>
